import script from "./SuccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessModal.vue?vue&type=script&setup=true&lang=js"

import "./SuccessModal.vue?vue&type=style&index=0&id=21cca2c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21cca2c4"]])

export default __exports__